import { dataStatic } from "./data-static";
import { dataDynamic } from "./data-dynamic";

export const data = [
  //spain
  {
    ...dataStatic.barcelona,
    ...dataDynamic["2817"].statistics,
  },
  {
    ...dataStatic.atmadrid,
    ...dataDynamic["2836"].statistics,
  },
  {
    ...dataStatic.real,
    ...dataDynamic["2829"].statistics,
  },
  //italy
  {
    ...dataStatic.inter,
    ...dataDynamic["2697"].statistics,
  },
  {
    ...dataStatic.milan,
    ...dataDynamic["2692"].statistics,
  },
  {
    ...dataStatic.juventus,
    ...dataDynamic["2687"].statistics,
  },
  //england
  {
    ...dataStatic.arsenal,
    ...dataDynamic["42"].statistics,
  },
  {
    ...dataStatic.manutd,
    ...dataDynamic["35"].statistics,
  },
  {
    ...dataStatic.chelsea,
    ...dataDynamic["38"].statistics,
  },
  {
    ...dataStatic.mancity,
    ...dataDynamic["17"].statistics,
  },
  {
    ...dataStatic.liverpool,
    ...dataDynamic["44"].statistics,
  },
  //france
  {
    ...dataStatic.psg,
    ...dataDynamic["1644"].statistics,
  },
  //germany
  {
    ...dataStatic.bayern,
    ...dataDynamic["2672"].statistics,
  },
  {
    ...dataStatic.dortmund,
    ...dataDynamic["2673"].statistics,
  },
  {
    ...dataStatic.bayer,
    ...dataDynamic["2681"].statistics,
  },
];
